import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 启用状态
 */
class Able extends UltMeta {
    ENABLE = new Meta(1, "已启用");
    DISABLE = new Meta(0, "已禁用", "color-info");
}

export const ABLE = new Able();

/**
 * 启用状态
 */
class RegularAble extends UltMeta {
    ENABLE = new Meta(0, "已启用");
    DISABLE = new Meta(1, "已禁用", "color-info");
}

export const REGULAR_ABLE = new RegularAble();

class DateQueryMode extends UltMeta {
    public SEVEN_DAYS = new Meta(1, "近一周", 7);
    public ONE_MONTH = new Meta(2, "近一月", 30);
    public ONE_YEAR = new Meta(3, "近一年", 12);
}

export const DATE_QUERY_MODE = new DateQueryMode();

/**
 * 品类指数定义
 */
class QuantityType extends UltMeta {
    SAND_INFO = new Meta(1, "砂石资讯");
    SAND_ACADEMY = new Meta(2, "砂石学院");
}
export const QUANTITY_TYPE = new QuantityType();

/**主题色 */
class ThemeColor extends UltMeta {
    Primary = new Meta("primary", "#EAF1FF", "#FFBE17");
    Error = new Meta("error", "#FFEFF0", "#F96666");
    Success = new Meta("success", "#D9F3F5", "#41C2C9");
    Info = new Meta("color-info", "#F2F2F2", "#999999");
    Warning = new Meta("warning", "#FFF5EA", "#F7AC46");
}
export const THEME_COLOR = new ThemeColor();

/**区分吨位 */
class HasDwt extends UltMeta {
    UNDIFFER_DWT = new Meta(0, "不区分吨位");
    DIFFER_DWT = new Meta(1, "区分吨位");
}
export const HAS_DWT = new HasDwt();

// /**吨位类型 */
class DwtType extends UltMeta {
    FIVE_SIX_THOUS = new Meta(1, "0.5-0.6万吨位");
    EIGHT_NINE__THOUS = new Meta(2, "0.8-0.9万吨位");
    ONE__THOUS = new Meta(3, "1万吨位");
    TWELVE__THOUS = new Meta(4, "1.2万吨位");
    ONE_AND_HALF_THOUS = new Meta(5, "1.5万吨位");
    ONE_AND_HALF_UP_THOUS = new Meta(6, "1.5万+吨位");
    NOT_THOUS = new Meta(7, "无吨位");
}
export const DWT_TYPE = new DwtType();

/**认证状态 */
export enum AUTHSTATUS {
    NO_CERTIFICATION_RECORD = -1,
    UNSUBMITTED_CERTIFICATION_APPLICATION = 1,
    CERTIFIED = 2,
    CERTIFICATION_FAILED = 3,
    CERTIFICATION_IN_PROGRESS = 4,
    EXPIRED = 6
}

/**契约锁签署类型 1是pc 2是小程序 */
class SignOrigin extends UltMeta {
    PC = new Meta(1, "PC");
    WX = new Meta(2, "小程序");
}
export const SIGN_ORIGIN = new SignOrigin();

export const enum OperationTypeEnum {
    Update = 1,
    Delete
}

/**
 * 排序
 */
class Sort extends UltMeta {
    ASC = new Meta("ascending", "asc", 1);
    DESC = new Meta("descending", "desc", 0);
}

export const SORT = new Sort();

/**
 * 连接状态
 */
class WebSocketReadyState extends UltMeta {
    CONNECTING = new Meta(0, "正在链接中");
    OPEN = new Meta(1, "已经链接并且可以通讯");
    CLOSING = new Meta(2, "连接正在关闭");
    CLOSED = new Meta(3, "连接已关闭或者没有链接成功");
}
export const WEBSOCKET_READY_STATE = new WebSocketReadyState();

/**
 * 页面类型
 */
class PageType extends UltMeta {
    LIST = new Meta(0, "列表");
    DETAIL = new Meta(1, "详情");
    LOG = new Meta(2, "记录");
    /**
     * 缓存表单页
     * 缓存的表单页提交成功后要调用 keepAliveStore.deleteCacheForm() 来删除缓存
     **/
    CACHE_FORM = new Meta(3, "表单");
}
export const PAGE_TYPE = new PageType();
